import React, { useEffect, useState } from "react";
import Card from "../../components/Card/Card";
import { toast } from "react-toastify";
import http from "../../http-common";
import {
  ButtonSet,
  RadioButton,
  RadioButtonGroup,
  Row,
} from "carbon-components-react";
import { Column } from "carbon-components-react";
import { TextInput } from "carbon-components-react";
import { useForm } from "react-hook-form";
import { Form } from "carbon-components-react";
import { Button } from "carbon-components-react";
import { useNavigate, useParams } from "react-router-dom";
import useAuth from "../../hooks/useAuth";
import { yupResolver } from "@hookform/resolvers/yup";
import {
  applicationScoreSchema,
  selfKnowledgeQuestionnaireSchema,
} from "../../services/SchemaService";
import CancelButton from "../../components/Buttons/CancelButton";
import SubmitButton from "../../components/Buttons/SubmitButton";

const CreateSelfKnowledgeQuestionnairePage = () => {
  const params = useParams();
  const [uuid] = useState(params.uuid);
  const { user } = useAuth();
  const [issues, setIssues] = useState([]);
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(selfKnowledgeQuestionnaireSchema),
    mode: "onBlur",
  });

  const getIssues = async () => {
    try {
      const response = await http.get("/self-knowledge/issues");
      setIssues(response.data);
    } catch (error) {
      toast.error("Erro ao carregar o questionário");
    }
  };

  useEffect(() => {
    getIssues();
  }, []);

  const onSubmit = async (data) => {
    try {
      const response = await http.post(
        `/self-knowledge/save-questionnaire?uuid=${uuid}&ids=${Object.values(
          data
        )}`
      );
      toast.success("Questionário e candidatura submetidos com sucesso");
      navigate("../submitted-candidature/" + uuid);
    } catch (error) {
      toast.error(error?.response?.data.message);
    }
  };

  return (
    <Card title="Questionário de auto-conhecimento">
      <h4>Queremos Conhecer-te Melhor...</h4>
      <p>
        Completa cada uma das frases abaixo com a opção que está mais adequada
        às tuas acções. Por favor selecciona aquela que você acredita ser a mais
        verdadeira, em vez da que você gostaria que fosse verdade. Mais uma vez
        é importante realçar que não existem respostas certas ou erradas.{" "}
      </p>
      <p>
        <strong>
          Lembra-te: Esta é uma oportunidade para conheceres melhor as tuas
          habilidades empreendedoras. Responde com a maior sinceridade possível.
        </strong>
      </p>
      <Form onSubmit={handleSubmit(onSubmit)}>
        {issues.map((i) => (
          <div className="mt-2" key={i.issueNumber}>
            <h5>
              {i.issueNumber}. {i.description}:
            </h5>
            <RadioButtonGroup
              legend="Group Legend"
              name={"issue" + i.issueNumber}
              orientation="vertical"
            >
              {i.options.map((o) => (
                <RadioButton
                  id={i.issueNumber + o.code}
                  key={i.issueNumber + o.code}
                  labelText={o.code + ". " + o.description}
                  value={o.id}
                  {...register("issue" + i.issueNumber)}
                />
              ))}
            </RadioButtonGroup>
            <p className="field-error">
              {errors["issue" + i.issueNumber]?.message}
            </p>
          </div>
        ))}

        <ButtonSet className="mt-2">
          <SubmitButton className={"emprega-bg-green"} />
          <CancelButton />
        </ButtonSet>
      </Form>
    </Card>
  );
};

export default CreateSelfKnowledgeQuestionnairePage;
